// tslint:disable:max-line-length
import * as React from 'react';
import { SvgIcon } from '../SvgIcon';

interface IProps {
	className?: string;
	closeQuote?: boolean;
	size?: number;
	largeQuote?: boolean;
}

export const QuoteIcon: React.SFC<IProps> = (props) => {
	const { className, closeQuote, size, largeQuote } = props;
	return (
		<SvgIcon
			className={ `quote-mark-icon ${ className || '' }` }
			height={ size }
			width={ size + 10 }
			viewBox={ largeQuote ? `0 0 ${ size } ${ size }` : `0 0 ${ size * 1.3 } ${ size * 1.3 }` }
		>
			{
				closeQuote ?
					<path d='M.484 27.578c2.848-1.543 5.044-3.471 6.586-5.785 1.602-2.373 2.492-5.132 2.67-8.277a5.102 5.102 0 01-2.314.534c-1.898 0-3.441-.564-4.628-1.691-1.127-1.187-1.69-2.73-1.69-4.628 0-2.077.622-3.738 1.868-4.984C4.222 1.442 5.795.789 7.693.789c2.374 0 4.302.95 5.785 2.848 1.484 1.899 2.225 4.539 2.225 7.921 0 4.45-1.127 8.425-3.382 11.926-2.254 3.5-5.37 6.29-9.345 8.366L.484 27.578zm20.381 0c2.848-1.543 5.044-3.471 6.586-5.785 1.602-2.373 2.492-5.132 2.67-8.277a5.102 5.102 0 01-2.314.534c-1.898 0-3.441-.564-4.628-1.691-1.127-1.187-1.69-2.73-1.69-4.628 0-2.077.622-3.738 1.868-4.984C24.603 1.442 26.176.789 28.074.789c2.374 0 4.302.95 5.785 2.848 1.484 1.899 2.225 4.539 2.225 7.921 0 4.45-1.127 8.425-3.382 11.926-2.254 3.5-5.37 6.29-9.345 8.366l-2.492-4.272z' fill='#046CB6' />
					:
					<path d='M15.991 5.06c-2.788 1.603-4.984 3.59-6.586 5.964-1.542 2.314-2.403 5.014-2.58 8.099a5.102 5.102 0 012.313-.534c1.84 0 3.323.593 4.45 1.78 1.187 1.187 1.78 2.73 1.78 4.628 0 2.077-.623 3.738-1.869 4.984s-2.818 1.869-4.717 1.869c-2.314 0-4.242-.92-5.785-2.76C1.514 27.193.772 24.553.772 21.17c0-4.45 1.128-8.425 3.382-11.926 2.255-3.56 5.4-6.378 9.434-8.455l2.403 4.272zm20.381 0c-2.788 1.603-4.984 3.59-6.586 5.964-1.542 2.314-2.403 5.014-2.58 8.099a5.102 5.102 0 012.313-.534c1.84 0 3.323.593 4.45 1.78 1.187 1.187 1.78 2.73 1.78 4.628 0 2.077-.623 3.738-1.869 4.984s-2.818 1.869-4.717 1.869c-2.314 0-4.242-.92-5.785-2.76-1.483-1.898-2.225-4.538-2.225-7.92 0-4.45 1.128-8.425 3.382-11.926 2.255-3.56 5.4-6.378 9.434-8.455l2.403 4.272z' fill='#046CB6' />
			}
		</SvgIcon>
	);
};
